import React from 'react';
import { CompassIcon, HeartIcon, SparklesIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const focuses = [{
  icon: HeartIcon,
  label: 'Situaciones sentimentales',
  text: 'Consultas sobre relaciones, vínculos personales y situaciones afectivas.'
}, {
  icon: SparklesIcon,
  label: 'Limpieza y protección',
  text: 'Prácticas tradicionales de limpieza y protección espiritual.'
}, {
  icon: CompassIcon,
  label: 'Orientación personal',
  text: 'Lecturas de tarot y acompañamiento espiritual personalizado.'
}];
export function DifficultSituation() {
  return <section aria-labelledby="situacion-title" className="relative overflow-hidden border-t border-silver/10 bg-violet-dark py-20 sm:py-28" data-id="element-14" data-mp="3r7m6j5i0ywon">
      <div aria-hidden="true" className="absolute left-1/2 top-0 h-72 w-[36rem] -translate-x-1/2 rounded-full bg-accent/15 blur-[130px]" data-id="element-15" data-mp="16fam2ydzr5gd" />
      <div className="relative mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-16" data-mp="11itn195976oi">
        <SectionHeading id="situacion-title" eyebrow="Acompañamiento" title="¿ESTÁS ATRAVESANDO UNA SITUACIÓN PERSONAL DIFÍCIL?" data-id="element-17" data-mp="oms090f5u73m">
          <div className="mx-auto max-w-2xl space-y-5 text-center text-[0.98rem] leading-relaxed text-silver sm:text-lg" data-id="element-18" data-mp="yl7tpa1ntsga">
            <p data-id="element-19" data-mp="13jj17e4hfqvc">
              Ofrecemos consultas y prácticas espirituales tradicionales
              relacionadas con situaciones sentimentales, personales y de
              orientación espiritual.
            </p>
            <p className="text-frost" data-id="element-20" data-mp="awom6wqfpjp9">
              Conoce nuestras opciones de consulta y descubre qué tipo de
              práctica puede estar relacionada con tu situación.
            </p>
          </div>
        </SectionHeading>

        <ul className="mt-14 grid gap-4 sm:grid-cols-3" data-id="element-21" data-mp="3jbzvxl0h8yk5">
          {focuses.map(({
          icon: Icon,
          label,
          text
        }) => <li key={label} className="rounded-xl border border-silver/15 bg-carbon/60 p-6 text-center backdrop-blur-sm" data-id="element-22" data-mp="3oajhhkb5s8bz">
              <Icon className="mx-auto h-6 w-6 text-accent-soft" aria-hidden="true" data-id="element-23" data-mp="3g8ahfl93j7eu" />
              <h3 className="mt-4 font-display text-lg font-light tracking-[0.08em] text-frost" data-id="element-24" data-mp="3q0q0klw4q21b">
                {label}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-silver/90" data-id="element-25" data-mp="3l1lsxzouscd3">{text}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}